import styled, { css } from 'styled-components'
import { desktopBreakpoint, wideScreenBreakpoint } from 'react-components'
import DynamicMarkdown from '../../app-components/dynamic-components/dynamic-markdown'

export const Section = styled.section(
    ({ theme }) => css`
        width: inherit;
        padding: ${theme.spacing.medium} 0 ${theme.spacing.xSmall};

        @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
            padding: ${theme.spacing.xLarge} 4rem ${theme.spacing.medium};
        }

        @media only screen and (max-width: ${desktopBreakpoint.min}px) {
            padding: ${theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.xSmall};
        }
    `,
)

export const Title = styled.h2`
    ${({ theme }) => css`
        font-family: ${theme.typography.font.family.lato};
        font-size: 1.5rem;
        font-weight: ${theme.typography.font.weight.bold};
        margin-bottom: 1.5rem;
        color: #282828;

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            font-size: 2rem;
        }
    `}
`

export const FaqList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`

export const FaqItem = styled.div`
    ${({ theme }) => css`
        border-bottom: 0.0625rem solid ${theme.colors.tfwBlackOpacity10};
    `}
`

export const QuestionButton = styled.button`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 0;
    background: none;
    border: none;
    cursor: pointer;
    text-align: left;
    transition: all 0.3s ease;

    &:hover {
        opacity: 0.8;
    }
`

export const Question = styled.h3`
    ${({ theme }) => css`
        font-family: ${theme.typography.font.family.lato};
        font-size: 1rem;
        font-weight: ${theme.typography.font.lato.weight.semiBold};
        color: ${theme.colors.tfwBlack87};
        margin: 0;
        flex: 1;

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            font-weight: ${theme.typography.font.weight.normal};
            font-size: 1rem;
            line-height: 1.5rem;
            vertical-align: middle;
        }
    `}
`

export const IconWrapper = styled.span<{ isOpen: boolean }>`
    ${({ theme, isOpen }) => css`
        display: flex;
        align-items: center;
        justify-content: center;
        transition: transform 0.3s ease;
        transform: ${isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
        font-size: 1.5rem;
        color: ${theme.colors.tfwBlack87};
    `}
`

export const AnswerWrapper = styled.div<{ isOpen: boolean }>`
    display: grid;
    grid-template-rows: ${({ isOpen }) => (isOpen ? '1fr' : '0fr')};
    transition: grid-template-rows 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    overflow: hidden;
`

export const AnswerContent = styled.div`
    min-height: 0;
`

export const CustomMarkdown = styled(DynamicMarkdown)(
    ({ theme }) => css`
        & ul,
        li {
            font: ${theme.typography.font.lato.weight.regular} ${theme.typography.font.size.medium} / 1.5rem
                ${theme.typography.font.family.lato};
            color: ${theme.colors.tfwBlack99};
            margin: ${theme.spacing.small} ${theme.spacing.medium};
            padding: 0;
        }

        & p,
        h1,
        h2,
        h3,
        h4,
        h5,
        h6 {
            font: ${theme.typography.font.lato.weight.regular} ${theme.typography.font.size.medium} / 1.5rem
                ${theme.typography.font.family.lato};
            color: ${theme.colors.tfwBlack99};
            margin: ${theme.spacing.medium} 0;
            padding: 0;
        }

        & strong {
            color: #4a4a4a;
        }

        & p:first-child {
            margin-top: 0;
        }

        & p:last-child {
            margin-bottom: 0;
        }

        & a {
            color: #016bd4;
            text-decoration: none;

            &:hover {
                color: #0159b8;
                text-decoration: underline;
            }
        }
    `,
)
